import React, { useState } from "react";
import pastYearData from "../data/pastYearData.json";
import "../css/PastYearQuestion.css";

export default function PastYearQuestion() {
  const [subject, setSubject] = useState(null);
  const [year, setYear] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  const basePath = "/pdf";

  // 过滤科目基于搜索
  const filteredSubjects = Object.keys(pastYearData).filter(subj =>
    subj.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // 获取总文件数
  const getTotalFiles = (subj) => {
    return Object.values(pastYearData[subj]).flat().length;
  };

  return (
    <div className="pyq-container">
      {/* 背景装饰 */}
      <div className="pyq-bg-decoration"></div>
      <div className="pyq-bg-pattern"></div>
      
      <div className="pyq-content-wrapper">
        {/* 标题区域 */}
        <div className="pyq-title-section">
          <div className="pyq-title-header">
            <div className="pyq-title-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/>
                <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
              </svg>
            </div>
            <h1 className="pyq-main-title">SPM Past Year Questions</h1>
          </div>
          <p className="pyq-subtitle">
            Access comprehensive collection of past examination papers and solutions
          </p>
        </div>

        {/* 搜索栏 */}
        <div className="pyq-search-section">
          <div className="pyq-search-wrapper">
            <svg className="pyq-search-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="11" cy="11" r="8"/>
              <path d="m21 21-4.35-4.35"/>
            </svg>
            <input
              type="text"
              placeholder="Search subjects..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="pyq-search-input"
            />
          </div>
        </div>

        {/* 科目选择 */}
        <div className="pyq-section">
          <h2 className="pyq-section-title">
            <svg className="pyq-section-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/>
              <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
            </svg>
            Select Subject
          </h2>
          <div className="pyq-subject-grid">
            {filteredSubjects.map((subj) => (
              <button
                key={subj}
                className={`pyq-subject-card ${subject === subj ? "pyq-active" : ""}`}
                onClick={() => {
                  setSubject(subj);
                  setYear(null);
                  setSelectedFile(null);
                }}
              >
                <div className="pyq-card-content">
                  <div className="pyq-card-info">
                    <h3 className="pyq-card-title">{subj}</h3>
                    <p className="pyq-card-subtitle">
                      {getTotalFiles(subj)} files available
                    </p>
                  </div>
                  <svg className="pyq-card-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polyline points="9,18 15,12 9,6"/>
                  </svg>
                </div>
              </button>
            ))}
          </div>
        </div>

        {/* 年份选择 */}
        {subject && (
          <div className="pyq-section pyq-fade-in">
            <h2 className="pyq-section-title">
              <svg className="pyq-section-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                <line x1="16" y1="2" x2="16" y2="6"/>
                <line x1="8" y1="2" x2="8" y2="6"/>
                <line x1="3" y1="10" x2="21" y2="10"/>
              </svg>
              Select Year
            </h2>
            <div className="pyq-year-grid">
              {Object.keys(pastYearData[subject]).map((yr) => (
                <button
                  key={yr}
                  className={`pyq-year-btn ${year === yr ? "pyq-active" : ""}`}
                  onClick={() => {
                    setYear(yr);
                    setSelectedFile(null);
                  }}
                >
                  {yr}
                </button>
              ))}
            </div>
          </div>
        )}

        {/* 文件列表 */}
        {year && (
          <div className="pyq-section pyq-fade-in">
            <h2 className="pyq-section-title">
              <svg className="pyq-section-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                <polyline points="14,2 14,8 20,8"/>
                <line x1="16" y1="13" x2="8" y2="13"/>
                <line x1="16" y1="17" x2="8" y2="17"/>
                <polyline points="10,9 9,9 8,9"/>
              </svg>
              Available Files
            </h2>
            <div className="pyq-file-grid">
              {pastYearData[subject][year].map((file) => (
                <button
                  key={file}
                  className={`pyq-file-card ${selectedFile === file ? "pyq-active" : ""}`}
                  onClick={() => setSelectedFile(file)}
                >
                  <div className="pyq-file-content">
                    <div className="pyq-file-icon">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                        <polyline points="14,2 14,8 20,8"/>
                        <line x1="16" y1="13" x2="8" y2="13"/>
                        <line x1="16" y1="17" x2="8" y2="17"/>
                        <polyline points="10,9 9,9 8,9"/>
                      </svg>
                    </div>
                    <div className="pyq-file-info">
                      <h3 className="pyq-file-title">
                        {file.replace(".pdf", "")}
                      </h3>
                      <p className="pyq-file-type">PDF Document</p>
                    </div>
                    <div className="pyq-file-actions">
                      <svg className="pyq-action-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                        <circle cx="12" cy="12" r="3"/>
                      </svg>
                      <svg className="pyq-action-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                        <polyline points="7,10 12,15 17,10"/>
                        <line x1="12" y1="15" x2="12" y2="3"/>
                      </svg>
                    </div>
                  </div>
                </button>
              ))}
            </div>
          </div>
        )}

        {/* PDF 预览 */}
        {selectedFile && (
          <div className="pyq-section pyq-fade-in">
            <div className="pyq-pdf-section">
              <div className="pyq-pdf-header">
                <h2 className="pyq-section-title">
                  <svg className="pyq-section-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                    <circle cx="12" cy="12" r="3"/>
                  </svg>
                  Document Preview
                </h2>
                <div className="pyq-pdf-actions">
                  <button className="pyq-download-btn">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                      <polyline points="7,10 12,15 17,10"/>
                      <line x1="12" y1="15" x2="12" y2="3"/>
                    </svg>
                    Download
                  </button>
                </div>
              </div>
              <div className="pyq-pdf-viewer">
                <iframe
                  src={`${basePath}/${subject}/${year}/${selectedFile}`}
                  title="PDF Viewer"
                  frameBorder="0"
                  width="100%"
                  height="800px"
                ></iframe>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}